import {
	dismissNotificationsWhere,
	hasNotificationId,
} from "@/entities/notification"
import { settleNotification } from "@/shared/api/websocket"
import { registerSessionCleanup } from "@/shared/lib/auth"

const pendingByFriend = new Map<number, number>()

export function trackVoiceNotification(
	friendId: number,
	notificationId: number,
): void {
	pendingByFriend.set(friendId, notificationId)
}

export function settleVoiceNotification(friendId: number): void {
	const notificationId = pendingByFriend.get(friendId)
	if (notificationId === undefined) return
	pendingByFriend.delete(friendId)
	dismissNotificationsWhere(hasNotificationId(notificationId))
	settleNotification(notificationId)
}

registerSessionCleanup(() => pendingByFriend.clear())
